import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Sparkle } from "@phosphor-icons/react";
import { api } from "../lib/api";

const formatDateShort = (iso, lang) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString(lang === "de" ? "de-CH" : lang === "fr" ? "fr-CH" : "it-CH", {
      day: "2-digit", month: "long", year: "numeric",
    });
  } catch { return iso; }
};

export default function PromoBanner() {
  const { t, i18n } = useTranslation();
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get("/promo/active")
      .then(({ data }) => { if (!cancelled) setPromo(data.promo); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!promo) return null;
  const ratePct = Math.round((promo.rate ?? 0) * 100 * 100) / 100;
  const lang = i18n.resolvedLanguage || "it";

  return (
    <div
      className="w-full bg-gradient-to-r from-[#E30613] via-[#FF1A27] to-[#E30613] text-white overflow-hidden"
      data-testid="promo-banner"
      role="status"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-2.5 flex items-center justify-center gap-3 text-center text-xs sm:text-sm">
        <Sparkle size={16} weight="fill" className="shrink-0 animate-pulse" />
        <div className="uppercase tracking-wider font-bold">
          <span className="font-black">{promo.label}</span>
          <span className="mx-2 opacity-70">·</span>
          {ratePct === 0
            ? t("promo_banner.zero_commission")
            : t("promo_banner.reduced_commission", { rate: ratePct })}
          <span className="mx-2 opacity-70">·</span>
          <span>{t("promo_banner.until")} {formatDateShort(promo.ends_at, lang)}</span>
        </div>
        <Sparkle size={16} weight="fill" className="shrink-0 animate-pulse" />
      </div>
    </div>
  );
}
